import React, { useContext, useState } from 'react';
import PropTypes from 'prop-types';
import { Layout, Menu, Badge as AntBadge, Modal, theme } from 'antd';
import { Link, useHistory, useLocation } from 'react-router-dom';
import URI from 'global_config/uri';
import { ReactComponent as HomeIcon } from 'icons/home.svg';
import { ReactComponent as AddIcon } from 'icons/add.svg';
import { ReactComponent as SearchIcon } from 'icons/search.svg';
import { ReactComponent as PleboIcon } from 'icons/syringe.svg';
import { ReactComponent as InventoryIcon } from 'icons/inventory.svg';
import { ReactComponent as CheckinIcon } from 'icons/clipboard-check.svg';
import { ReactComponent as SearchPatientIcon } from 'icons/searchpatient.svg';
import { ReactComponent as SettingsIcon } from 'icons/settings.svg';
// import { ReactComponent as PrintIcon } from 'icons/fax-machine.svg';
import { ReactComponent as EditIcon } from 'icons/edit_2.svg';
import { ReactComponent as BloodBankIcon } from 'icons/blood-bank.svg';
import { ReactComponent as RequestIcon } from 'icons/request.svg';
import { SELECTED_SIDER_KEY } from 'global_config/constant-global';
import { UserAccessContext } from 'context/userAccess';
import { SnippetsFilled, ExclamationCircleOutlined } from '@ant-design/icons';

import {
	LR_SEL_EXAMS,
	LR_OTHER_INFO,
	LR_PERSONAL_INFO,
	LR_EDIT_SEL_EXAM_REF,
	LR_REQUEST_TYPE,
} from 'modules/main/lab_request/steps/constants';

import Icon from '@ant-design/icons';
import './sider.css';

const { Sider: AntSider } = Layout;

function Sider({ collapsed }) {
	const { userAccess } = useContext(UserAccessContext);
	// const { forExtrationPatientLength } = this.props;
	const history = useHistory();
	const [confirmVisible, setConfirmVisible] = useState(false);
	const [pendingHref, setPendingHref] = useState(null);
	const location = useLocation();

	  function safeParse(key) {
			try {
				const raw = sessionStorage.getItem(key);
				if (!raw) return null;
				return JSON.parse(raw);
			} catch (err) {
				// invalid JSON or other error -> treat as null
				return null;
			}
    	}

		// console.log('location.pathname =>', location.pathname);

    // generic emptiness check for arrays/objects/strings/null
    function isEmptyValue(v) {
        if (v == null) return true;
        if (Array.isArray(v)) return v.length === 0;
        if (typeof v === 'object') return Object.keys(v).length === 0;
        if (typeof v === 'string') return v.trim() === '';
        return false;
    }

	// show confirm modal when link clicked
	function handleInterceptLink(e, href) {
		e.preventDefault();
		// setPendingHref(href);
		// setConfirmVisible(true);
		
		const exams = (safeParse(LR_SEL_EXAMS));
		const otherInfo = (safeParse(LR_OTHER_INFO));
		const personalInfo = (safeParse(LR_PERSONAL_INFO));
		const examRef = (safeParse(LR_EDIT_SEL_EXAM_REF));

		console.log('exams =>', exams);
		console.log('otherInfo =>', otherInfo);
		console.log('personalInfo =>', personalInfo);
		console.log('examRef =>', examRef);

		const hasUnsaved =
            !isEmptyValue(exams) ||
            !isEmptyValue(otherInfo) ||
            !isEmptyValue(personalInfo) ||
            !isEmptyValue(examRef);

		// console.log('hasUnsaved =>', hasUnsaved);

		 if (hasUnsaved === true) {
            setPendingHref(href);
            setConfirmVisible(true);
        } else {
            history.push(href);
            setPendingHref(null);
        }

	}

	function handleConfirmNavigate() {
		setConfirmVisible(false);
		if (pendingHref) {
			['LR_SEL_EXAMS','LR_OTHER_INFO','LR_PERSONAL_INFO', 'LR_EDIT_SEL_EXAM_REF'].forEach(k => sessionStorage.removeItem(k));
			history.push(pendingHref);
			setPendingHref(null);
		}
	}

	function handleCancelNavigate() {
		setConfirmVisible(false);
		setPendingHref(null);
	}

	function handleMenuClick({ key }) {
		const selectedKey = key.includes('inventory') ? 9 : key;
		sessionStorage.setItem(SELECTED_SIDER_KEY, selectedKey);
		// workaround to avoid delays in stepsPage
		if (key === '2') sessionStorage.setItem(LR_REQUEST_TYPE, 'create');
		if (key === '3') sessionStorage.setItem(LR_REQUEST_TYPE, 'edit');
	}

	return (
		<AntSider trigger={null} collapsible collapsed={collapsed}>
			<div className="logo" />
			<Menu
				className="side-menu"
				mode="inline"
				defaultSelectedKeys={[sessionStorage.getItem(SELECTED_SIDER_KEY) || '1']}
				onClick={handleMenuClick}
			>
				{userAccess.dashboard.view && process.env.REACT_APP_DISPLAY_HOME === '1' && (
					<Menu.Item key={URI.dashboard.key}>
						{/* <Link to={URI.dashboard.link}> */}
						<a href={URI.dashboard.link} onClick={e => handleInterceptLink(e, URI.dashboard.link)}>
							<Icon component={HomeIcon} />
							<span>DASHBOARD</span>
						</a>
						{/* </Link> */}
					</Menu.Item>
				)}
				{userAccess.createRequest.view && process.env.REACT_APP_DISPLAY_LAB_REQUEST === '1' && (
					<Menu.Item key={URI.createLabReq.key}>
						{/* <Link to={URI.createLabReq.link}> */}
						<a href={URI.createLabReq.link} onClick={e => handleInterceptLink(e, URI.createLabReq.link)}>
							<Icon component={AddIcon} />
							<span>CREATE REQUEST</span>
						</a>
						{/* </Link> */}
					</Menu.Item>
				)}
				{userAccess.editRequest.view && process.env.REACT_APP_DISPLAY_EDIT_REQUEST === '1' && (
					<Menu.Item key={URI.editLabReq.key}>
						<a href={URI.editLabReq.link} onClick={e => handleInterceptLink(e, URI.editLabReq.link)}>
							<Icon component={EditIcon} />
							<span>EDIT REQUEST</span>
						</a>
					</Menu.Item>
				)}
				{userAccess.viewRequest.view && process.env.REACT_APP_DISPLAY_VIEW_REQUEST === '1' && (
					<Menu.Item key={URI.viewLabReq.key}>
						<a href={URI.viewLabReq.link} onClick={e => handleInterceptLink(e, URI.viewLabReq.link)}>
							<Icon component={RequestIcon} />
							<span>VIEW REQUEST</span>
						</a>
					</Menu.Item>
				)}
				{userAccess.plhebo.view && process.env.REACT_APP_DISPLAY_PHLEBO === '1' && (
					<Menu.Item key={URI.phlebo.key}>
						<a href={URI.phlebo.link} onClick={e => handleInterceptLink(e, URI.phlebo.link)}>
							<Icon component={PleboIcon} />
							<span>PHLEBO</span>
							<span>{/* <AntBadge count={forExtrationPatientLength} /> */}</span>
						</a>
					</Menu.Item>
				)}
				{userAccess.checkIn.view && process.env.REACT_APP_DISPLAY_CHECKIN === '1' && (
					<Menu.Item key={URI.checkIn.key}>
						<a href={URI.checkIn.link} onClick={e => handleInterceptLink(e, URI.checkIn.link)}>
							<Icon component={CheckinIcon} />
							<span>CHECK-IN</span>
						</a>
					</Menu.Item>
				)}
				{userAccess.result.view && process.env.REACT_APP_DISPLAY_LAB_RESULT === '1' && (
					<Menu.Item key={URI.editLabResult.key}>
						<a href={URI.editLabResult.link} onClick={e => handleInterceptLink(e, URI.editLabResult.link)}>
							<Icon component={SearchIcon} />
							<span>LABORATORY RESULT</span>
						</a>
					</Menu.Item>
				)}
				{/* {
					process.env.REACT_APP_DISPLAY_PRINT_RESULT === '1' && (
						<Menu.Item key={URI.printLabResult.key}>
							<Link to={URI.printLabResult.link}>
								<Icon component={PrintIcon} />
								<span>PRINT LAB RESULT</span>
							</Link>
						</Menu.Item>
					)
				} */}
				{userAccess.patientDemographics.view &&
					process.env.REACT_APP_DISPLAY_SEARCH_PATIENT === '1' && (
						<Menu.Item key={URI.searchPatient.key}>
							<a href={URI.searchPatient.link} onClick={e => handleInterceptLink(e, URI.searchPatient.link)}>
								<Icon component={SearchPatientIcon} />
								<span>EDIT PATIENT DEMOGRAPHICS</span>
							</a>
						</Menu.Item>
					)}

				{userAccess.dataAnalysis.view && process.env.REACT_APP_DISPLAY_DATAANALYSIS === '1' && (
					<Menu.Item key={URI.dataAnalysis.key}>
						<a href={URI.dataAnalysis.link} onClick={e => handleInterceptLink(e, URI.dataAnalysis.link)}>
							<SnippetsFilled />
							<span>DATA ANALYSIS</span>
						</a>
					</Menu.Item>
				)}
				{userAccess.settings.view && process.env.REACT_APP_DISPLAY_SETTINGS === '1' && (
					<Menu.Item key={URI.settings.key}>
						<a href={URI.settings.link} onClick={e => handleInterceptLink(e, URI.settings.link)}>
							<Icon component={SettingsIcon} />
							<span>SETTINGS</span>
						</a>
					</Menu.Item>
				)}

				{process.env.REACT_APP_DISPLAY_INVENTORY === '1' && (
					<Menu.Item key={URI.inventory.key}>
						<a href={URI.inventory.link} onClick={e => handleInterceptLink(e, URI.inventory.link)}>
							<Icon component={InventoryIcon} />
							<span>INVENTORY</span>
						</a>
					</Menu.Item>
				)}
				{userAccess.settings.view && process.env.REACT_APP_DISPLAY_BLOODBANK === '1' && (
					<Menu.Item key={URI.bloodbank.key}>
						<a href={URI.bloodbank.link} onClick={e => handleInterceptLink(e, URI.bloodbank.link)}>
							<Icon component={BloodBankIcon} />
							<span>BLOOD BANK</span>
						</a>
					</Menu.Item>
				)}
				{process.env.REACT_APP_DISPLAY_CASHIER === '1' && (
					<Menu.Item key={URI.cashier.key}>
						<a href={URI.cashier.link} onClick={e => handleInterceptLink(e, URI.cashier.link)}>
							<Icon component={SearchPatientIcon} />
							<span>CASHIER</span>
						</a>
					</Menu.Item>
				)}
			</Menu>
			<Modal 
				visible={confirmVisible} 
				onOk={handleConfirmNavigate} 
				onCancel={handleCancelNavigate}
				centered
			>
				<div style={{ display: 'flex', alignItems: 'center'}}>
					<ExclamationCircleOutlined style={{ fontSize: 48, color: '#8A73F9', marginRight: 12}} />
					<p style={{ margin: 0 }}>You are about to navigate to a different page and by continuing, you may lose unsaved changes. Do you wish to proceed?</p>
				</div>
			</Modal>
		</AntSider>
	);
}

Sider.propTypes = {
	collapsed: PropTypes.bool,
};

Sider.defaultProps = {
	collapsed: null,
};

export default Sider;
